import { Style, StatusBar } from '@capacitor/status-bar';
// import { NavigationBar } from '@hugotomazi/capacitor-navigation-bar';

import { isPlatform } from '@ionic/vue';


interface UpdateStatusBarOptions {
  transparentStatusBar?: boolean;
  backgroundColor?: string;
  backgroundBottomColor?: string;
  buttonsBottomDark?: boolean;
}

export function componentToHex(c: number): string {
  const hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

export function isDark(): boolean {
  const html = document.querySelector('html');
  return Boolean(html && html.classList.contains("dark"));
}

export async function updateAndroidBar(options: UpdateStatusBarOptions, style?: Style) {
  if (!isPlatform('capacitor') || !isPlatform('android')) return;

  if (!style) style = isDark() ? Style.Dark : Style.Light;

  StatusBar.setBackgroundColor({ color: '#00000000' });
  StatusBar.setOverlaysWebView({ overlay: true });

  StatusBar.setStyle({ style });
}

export function updateIosBar(options: UpdateStatusBarOptions, style?: Style) {
  if (!isPlatform('capacitor') || !isPlatform('ios')) return;

  if (style) {
    StatusBar.setStyle({ style });
  } else {
    if (isDark()) StatusBar.setStyle({ style: Style.Dark });
    if (!isDark()) StatusBar.setStyle({ style: Style.Light });
  }
}

export function updateStatusBar(options?: UpdateStatusBarOptions) {
  options = options || {};

  if (!isPlatform('capacitor')) return;

  StatusBar.show();

  updateAndroidBar(options);
  updateIosBar(options);
}

